import { ZValidation } from "./lib/validation";

/** 送信ボタン */
const submit_button: HTMLElement = document.getElementById('btn_submit') as HTMLElement;

/** プライバシーポリシーのチェック値 */
const privacy_check: HTMLElement = document.getElementById('privacy') as HTMLElement;

/**
 * ページロード
 */
window.addEventListener('DOMContentLoaded', () => {
    // 入力内容確認画面からの遷移
    if (document.referrer.indexOf('/contact/confirm') >= 0) {
        // バリデーション実行
        execValidation();
    } else {
        // 送信ボタン無効
        inValid();
    }
});

/**
 * キーイベント
 */
document.getElementById('contact_form')?.addEventListener('keydown', (e) => {
    // Enterキーで送信しないようにする
    if (e.key === 'Enter') {

        const target: HTMLElement = e.target as HTMLElement;

        // textarea以外はブロックする
        if (target.tagName != 'TEXTAREA') {       
            e.preventDefault();
        }
    }
})

/**
 * プライバシーポリシーのチェックイベント
 */
privacy_check.addEventListener('change', () => {
    // バリデーション
    execValidation();
})

/**
 * フォーカスアウト
 */
window.addEventListener('focusout', (event) => {
    // バリデーション
    execValidation();
});

/**
 * 送信イベント
 */
document.getElementById('btn_submit')?.addEventListener('click', (event) => {
    // バリデーション
    execValidation();
})

/**
 * バリデーション実行
 */
function execValidation(): void {
    try {

        // バリデーションクラス作成
        const validator: ZValidation = makeValidator();

        // バリデーション実行
        if (!validator.validation()) {
            // エラー取得
            const errors: object = validator.errors;
            inValid(errors);
        } else {
            Valid();
        }
    } catch (e) {
        console.log(e);
    }
}

function makeValidator(): ZValidation {

    // 入力値取得
    const inputData: object = getInput();

    return new ZValidation(
        {
            // 入力値
            ...inputData
        },
        {
            // rule
            'company_name': 'required|max:50',
            'last_name': 'required|max:50',
            'last_name_kana': 'required|max:50',
            'first_name': 'required|max:50',
            'first_name_kana': 'required|max:50',
            'email': 'required|max:255',
            'contact_type': 'required',
            'title': 'required|max:100',
            'content': 'required|max:1000',
            'privacy': 'required',
        },
        {
            // ラベル
            'company_name': '会社名',
            'last_name': 'お名前(姓)',
            'last_name_kana': 'お名前カナ(姓)',
            'first_name': 'お名前(名)',
            'first_name_kana': 'お名前カナ(名)',
            'email': 'メールアドレス',
            'title': 'お問い合わせの件名',
            'content': 'お問い合わせ内容',
            'privacy': 'プライバシーポリシー',
        }
    )
}

function getInput(): object {
    const ids: Array<string> = [
        'company_name',
        'last_name',
        'last_name_kana',
        'first_name',
        'first_name_kana',
        'email',
        'contact_type',
        'title',
        'content',
        'privacy'
    ];

    let input: object = {};

    ids.forEach((value) => {
        const element: HTMLInputElement = document.getElementById(value) as HTMLInputElement

        switch (element.type) {
            case 'text':
            case 'select-one':
            case 'textarea':
            case 'email':
                input = {...input, [value]: element.value};
                break;
            case 'checkbox':
                input = {...input, [value]: element.checked ? '1' : ''};
                break;
        }
    });

    return input;
}

/**
 * 送信ボタン無効化
 */
const inValid = (errors?: object) => {
    // エラー情報表示
    if (errors != undefined) {
        Object.keys(errors).forEach((value: string) => {
            // keyからエラーメッセージを表示する指定要素を特定
            const targetElement = document.getElementById('input_' + value);

            // タグの後にエラーメッセージを追加
            const errorElement = document.createElement('div');
            errorElement.classList.add('error');
            errorElement.id = value + '_error';
            
            errorElement.textContent = errors[value];
            
            // 指定要素の後にエラーを追加
            targetElement?.appendChild(errorElement);
        });
    }

    submit_button.disabled = true;
    submit_button.classList.remove('button');
    submit_button.classList.add('button-disabled'); 
}

const Valid = () => {
    submit_button.disabled = false;
    submit_button.classList.remove('button-disabled'); 
    submit_button.classList.add('button');
}